import messages from '../../../locale/messages';
import { inputTextLimit } from '../../../helpers/inputTextLimit';

const validate = values => {
    const errors = {};

    if (values.citySectionTitle1) {
        let errorsCitySectionTitle = [];

        values.citySectionTitle1.forEach((item, index) => {
            
            const citySectionError = {};

            if (!item?.value || item?.value.toString().trim() === '') {
                citySectionError.value = messages.required;
            } else if (item?.value?.length < 2) {
                citySectionError.value = messages.required;
            } else if (item?.value?.length > inputTextLimit) {
                citySectionError.value = messages.inputTextLimitError;
            }

            if (!item?.language || item?.language.toString().trim() === '') {
                citySectionError.language = messages.required;
            }

            if (Object.keys(citySectionError).length > 0) {
                errorsCitySectionTitle[index] = citySectionError;
            }
        });

        if (errorsCitySectionTitle.length > 0) {
            errors.citySectionTitle1 = errorsCitySectionTitle;
        }
    }

    return errors;
};

export default validate;